import { type ReactNode, useCallback } from 'react';

import { ImagesIcon } from '@air/design-icons';
import { useToasts } from '@air/provider-toast';

export const useLibraryToasts = () => {
  const { showToast } = useToasts();

  const showLibraryToast = useCallback(
    ({ message, type = 'info' }: { message: ReactNode; type?: 'error' | 'info' }) => {
      showToast(message, {
        color: type === 'error' ? 'red' : 'black',
        prefix: <ImagesIcon size="sm" />,
        withCloseButton: true,
      });
    },
    [showToast],
  );

  return { showLibraryToast };
};
